import axios from "axios";
import {API_URL} from "../config";
import jsonToFormData from "json-form-data";

export const updatePayoutService = async (id, values) => {

    let options = {
        initialFormData: new FormData(),
        showLeafArrayIndexes: true,
        includeNullValues: true
    };

    let data = {...values};

    data._method = 'PUT';

    if(typeof data.voucher === 'string')
        delete data.voucher;

    const formData = jsonToFormData(data, options);

    return axios.post(`${API_URL}/payouts/${id}`, formData);
};
export const getPayoutService = async (id) => {
    return axios.get(`${API_URL}/payouts/${id}`);
}
